import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { Entitlements, EntitlementsService } from '@treasury/domain/entitlements';
import { Feature } from '@treasury/domain/services/feature-flags';
import { TmContainer } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

export const tagName = 'wires-container-tabs';
@customElement(tagName)
export class WiresContainerTabs extends TmContainer {
    @InjectProperty()
    declare private entitlementsService: EntitlementsService;

    @state()
    private tabs = [
        { label: 'One Time', id: 'OneTime', enabled: true },
        { label: 'Recurring', id: 'Recurring', enabled: true },
        { label: 'Wire File Activity', id: 'WireFile', enabled: false },
        { label: 'Wire File Formats', id: 'WireFileFormats', enabled: false },
        { label: 'Creditors', id: 'Creditors', enabled: false },
        { label: 'Templates', id: 'Templates', enabled: false },
    ];

    @state()
    private activeTab = '';

    @state()
    private domesticEntitlement = false;

    @state()
    private internationalEntitlement = false;

    @state()
    private wireFileFeatureFlagEnabled = false;

    @state()
    private hasWireFileUploadFeatureFlagEnabled = false;

    @state()
    private wireTemplatesFeatureFlagEnabled = false;

    private get hasWireEntitlement() {
        return this.domesticEntitlement || this.internationalEntitlement;
    }

    protected render() {
        const enabledTabs = this.tabs.filter(tab => tab.enabled);
        return html`<tm-tabs
            .tabs=${enabledTabs}
            .activeTab=${this.activeTab}
            @switchTab=${({ detail }: CustomEvent) => {
                this.activeTab = detail.activeTab;
            }}
        ></tm-tabs>`;
    }

    protected async firstUpdated() {
        this.domesticEntitlement = await this.entitlementsService.isEnabled(
            Entitlements.CreateDomesticWire
        );
        this.internationalEntitlement = await this.entitlementsService.isEnabled(
            Entitlements.CreateInternationalWire
        );
        this.wireFileFeatureFlagEnabled = await (
            await this.featureFlagService
        ).isEnabled(Feature.PwaWireFileActivity);
        this.hasWireFileUploadFeatureFlagEnabled = await (
            await this.featureFlagService
        ).isEnabled(Feature.PwaWireFileUpload);
        this.wireTemplatesFeatureFlagEnabled = await (
            await this.featureFlagService
        ).isEnabled(Feature.PwaWireTemplatesList);

        if (this.isDesktop) {
            this.tabs.map(tab => {
                if (tab.id === 'WireFile') {
                    tab.enabled = this.wireFileFeatureFlagEnabled;
                }
                if (tab.id === 'WireFileFormats') {
                    tab.enabled = this.hasWireFileUploadFeatureFlagEnabled;
                }
                if (tab.id === 'Creditors') {
                    tab.enabled = true;
                }
                if (tab.id === 'Templates') {
                    tab.enabled = this.wireTemplatesFeatureFlagEnabled && this.hasWireEntitlement;
                }
            });
        }
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: WiresContainerTabs;
    }
}
